module.exports = __webpack_public_path__ + "77c6af807fa45528e176e04649f5ecdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/gifts/postal-voucher-bg.jpg
// module id = 2448
// module chunks = 15